<template>
  <div class="docdetail">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path:'/doctor' }">名医工作室</el-breadcrumb-item>
      <el-breadcrumb-item>{{doctorname}}工作室</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="docdetail_center">
      <div class="docdetail_content_alt">
        名医工作室
        <span></span>
      </div>
      <div class="docdetail_content">
        <img :src="doctorArr.avatar" class="docdetail_headimg" />
        <div class="docdetail_introduce">
          <p class="dcin_head">
            <img src="../../assets/doctor/cert_icon@2x.png" />{{doctorname}}
            <span>工作室</span>
          </p>
          <div class="dcin_content">
            <div v-for="(item,index) in listArr" :key="index">{{item}}</div>
          </div>
        </div>
      </div>
      <div class="about_book">
        <div class="abook_title">相关标注的古籍<div class="sbook_change" @click="loaddoctor"><span></span>换一批</div></div>
        <ul class="abook_content">
          <li
            class="anbc_li"
            v-for="(item,index) in aboutArr"
            v-bind:key="index"
            @click="book(item)"
          >
            <div class="anbc_li_head" ref="bookbg" :style="{backgroundColor:item.background}">
              <img src="../../assets/public/book.png" class="anbc_img" />
              <img src="../../assets/public/shadow_bg@2x.png" alt class="shadow" />
            </div>
            <p class="anbc_p">{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import data from '../../../static/doctors.json'
export default {
  data() {
    return {
      listArr: [],
      aboutArr: [],
      bgcolor: ["#E2F9FF", "#FFE4E4", "#FFF6E4", "#F4F4F4", "#E4ECFF"],
      doctorArr:[]
    };
  },
  created() {
    this.doctorname = this.$route.query.name
    this.loaddoctor();
    this.loadabout();
  },
  methods: {
    loaddoctor() {
      var that = this;
      for(var c = 0;c<data.length;c++){
        if(that.doctorname == data[c].name){
          that.doctorArr = data[c]
        }
      }
      this.listArr = this.doctorArr.info.split("/n");
     
    },
    loadabout(){
      var that = this;
       this.aboutArr = []
      for(var j = 0;j<4;j++){
        this.aboutArr.push({
          name: "本草纲目"
        });
      }
      var rand = ''
      for (var i = 0; i < that.aboutArr.length; i++) {
        var a = parseInt(5 * Math.random());
        if (rand != a) {
          that.aboutArr[i]["background"] = that.bgcolor[a];
        } else {
          i = i - 1;
          continue;
        }
        rand = a;
      }
      // console.log(that.aboutArr)
    },
    book(item){

    }
  }
};
</script>
<style lang="scss" scoped>
.docdetail {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 60px;
  .docdetail_center {
    width: 100%;
    // border: 1px solid red;
    background: #fff;
    padding-top: 40px;
    padding-bottom: 60px;
    margin-bottom: 60px;
    .docdetail_content_alt {
      width: fit-content;
      height: 31px;
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #333;
      margin-left: 60px;
      position: relative;
      z-index: 2;
      span {
        width: 100%;
        height: 6px;
        display: inline-block;
        position: absolute;
        bottom: 1px;
        left: 0;
        z-index: -1;
        background: #e6522b;
      }
    }
    .docdetail_content {
      width: 1080px;
      // height: 530px;
      // border: 1px solid red;
      display: flex;
      margin: 0 auto;
      margin-top: 40px;
      border-bottom: 1px solid rgba(210, 210, 210, 0.41);
      .docdetail_headimg {
        width: 315px;
        height: 390px;
        display: block;
        margin-bottom: 102px;
					object-fit: cover;
      }
      .docdetail_introduce {
        width: 680px;
        // min-height: 490px;
        // border: 1px solid red;
        margin-left: 52px;
        .dcin_head {
          height: 30px;
          line-height: 30px;
          font-size: 30px;
          color: #333;
          font-family: FZGB10;
          font-weight: bold;
          img {
            width: 30px;
            height: 30px;
            vertical-align: top;
            margin-right: 7px;
          }
          span {
            font-size: 20px;
          }
        }
        .dcin_content {
          width: 100%;
          position: relative;
          margin-top: 15px;
          color: #333;
          div {
            width: 100%;
            padding-left: 37px;
            box-sizing: border-box;
            position: relative;
            margin-top: 18px;
            font-family: PingFangSC-Regular;
            line-height: 33px;
            &:first-child {
              margin-top: 0px;
            }
            &::before {
              content: "";
              position: absolute;
              top: 13px;
              left: 8px;
              background: #fff;
              height: 9px;
              width: 9px;
              border: 1px solid #ad896b;
            }
          }
          &::before {
            content: "";
            position: absolute;
            top: 13px;
            left: 13px;
            height: calc(100% - 16px);
            width: 1px;
            background: #ad896b;
          }
        }
      }
    }
    .about_book {
      width: 1080px;
      margin: 0 auto;
      margin-top: 54px;
      // border: 1px solid red;
      .abook_title {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        .sbook_change{
          float: right;
          color: #AD896B;
          font-weight: 400;
          font-size: 16px;
          cursor: pointer;
          span{
            width: 18px;
            height: 18px;
            display: inline-block;
            vertical-align: top;
            background: url(../../assets/doctor/change_nor.png) no-repeat center center;
            background-size: 100%;
            margin-right: 2px;
          }
          &:hover{
            color: #744014;
            span{
              background: url(../../assets/doctor/change_pre.png) no-repeat center center;
              background-size: 100%;
            }
          }
        }
      }
      .abook_content {
        width: 100%;
        box-sizing: border-box;
        // padding: 35px 30px 0;
        background-color: #fff;
        margin-top: 50px;
        display: flex;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        flex-wrap: wrap;
        justify-content: space-between;
        align-content: flex-start;
        align-items: flex-start;
        &::after {
          content: "";
          width: 230px;
        }
        .anbc_li {
          width: 240px;
          cursor: pointer;
          // margin-bottom: 28px;
          .anbc_li_head {
            width: 100%;
            height: 173px;
            position: relative;
            &:hover {
              box-shadow: 0px 1px 11px 1px rgba(0, 0, 0, 0.07);
            }
            .anbc_img {
              width: 96px;
              height: 120px;
              margin-top: 28px;
              margin-left: 74px;
            }
            .shadow {
              width: 130px;
              height: 148px;
              position: absolute;
              bottom: 10px;
              left: 62px;
            }
          }
          .anbc_p {
            color: #333;
            text-align: center;
            margin-top: 14px;
            font-size: 16px;
            font-family: FZGB10;;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/page/doctorDetail.vue